// extracted by mini-css-extract-plugin
export default {"adjusmentsItem":"AdjusItem_adjusmentsItem__kB9pJ"};